import "./header.scss";
import { useNavigate } from "react-router-dom";
import { AnimatePresence } from "motion/react";
import * as motion from "motion/react-client";
import { dashboardTransition } from "../transitions";

export default function Header() {
  const navigate = useNavigate();

  return (
    <AnimatePresence>
      <motion.header className="header" {...dashboardTransition}>
        <img
          onClick={() => {
            navigate("/");
          }}
          className="header__logo"
          src="logo.svg"
        />
        <span className="header__title">Road to Recharge</span>
      </motion.header>
    </AnimatePresence>
  );
}
